import React from "react";
import { Panel, PanelHeader, PanelContent } from "@flixbus/honeycomb-react";
import { IconArrowLeftL } from "@flixbus/honeycomb-icons-react";
import AiChat, { type AiChatProps } from "./chat/AiChat.component";
import ChatHeader from "./chat/ChatHeader.component";
import { panelId } from "./CreateCalculationPanel.constants";
import styles from "./CreateCalculationPanel.module.scss";

export interface AiDraftPanelProps {
  active: boolean;
  aiChat: AiChatProps;
  /** Return to the wizard (step 3, form preserved) so the user can revisit the header. */
  onBack: () => void;
  onClose: () => void;
}

/** The "Draft with AI" panel: the wizard's `mode === "aiDraft"` branch, rendering
 *  the chat surface in place of the step body. Reuses the panel shell so it reads
 *  as the same overlay the user opened. */
const AiDraftPanel: React.FC<AiDraftPanelProps> = ({
  active,
  aiChat,
  onBack,
  onClose,
}) => (
  <Panel
    id={panelId}
    active={active}
    hasOverlay
    onOverlayClick={onClose}
    extraClasses={styles.panel}
  >
    <PanelHeader
      backButtonProps={{
        label: "Back to calculation details",
        onClick: onBack,
        InlineIcon: IconArrowLeftL,
      }}
      closeButtonProps={{ label: "Close", onClick: onClose }}
    >
      <ChatHeader />
    </PanelHeader>
    <PanelContent extraClasses={styles.panelContent}>
      <AiChat {...aiChat} />
    </PanelContent>
  </Panel>
);

export default React.memo(AiDraftPanel);
